var map = {
	"./editorBaseApi": 265308,
	"./editorBaseApi.js": 265308,
	"./editorSimpleWorker": 718941,
	"./editorSimpleWorker.js": 718941,
	"./editorWorker": 68633,
	"./editorWorker.js": 68633,
	"./editorWorkerHost": 151883,
	"./editorWorkerHost.js": 151883,
	"./findSectionHeaders": 78662,
	"./findSectionHeaders.js": 78662,
	"./getIconClasses": 604337,
	"./getIconClasses.js": 604337,
	"./languageFeatureDebounce": 581239,
	"./languageFeatureDebounce.js": 581239,
	"./languageFeatures": 70015,
	"./languageFeatures.js": 70015,
	"./languageFeaturesService": 420920,
	"./languageFeaturesService.js": 420920,
	"./languageService": 874457,
	"./languageService.js": 874457,
	"./languagesAssociations": 473543,
	"./languagesAssociations.js": 473543,
	"./languagesRegistry": 292652,
	"./languagesRegistry.js": 292652,
	"./markerDecorations": 327929,
	"./markerDecorations.js": 327929,
	"./markerDecorationsService": 713394,
	"./markerDecorationsService.js": 713394,
	"./model": 967093,
	"./model.js": 967093,
	"./modelService": 401374,
	"./modelService.js": 401374,
	"./resolverService": 166921,
	"./resolverService.js": 166921,
	"./semanticTokensDto": 167011,
	"./semanticTokensDto.js": 167011,
	"./semanticTokensProviderStyling": 368964,
	"./semanticTokensProviderStyling.js": 368964,
	"./semanticTokensStyling": 942688,
	"./semanticTokensStyling.js": 942688,
	"./semanticTokensStylingService": 198401,
	"./semanticTokensStylingService.js": 198401,
	"./textModelSync/textModelSync.impl": 783239,
	"./textModelSync/textModelSync.impl.js": 783239,
	"./textModelSync/textModelSync.protocol": 892797,
	"./textModelSync/textModelSync.protocol.js": 892797,
	"./textResourceConfiguration": 652559,
	"./textResourceConfiguration.js": 652559,
	"./treeSitterParserService": 103783,
	"./treeSitterParserService.js": 103783,
	"./treeViewsDnd": 754122,
	"./treeViewsDnd.js": 754122,
	"./treeViewsDndService": 761295,
	"./treeViewsDndService.js": 761295,
	"./unicodeTextModelHighlighter": 563664,
	"./unicodeTextModelHighlighter.js": 563664,
	"node_modules/monaco-editor/esm/vs/editor/common/services/editorBaseApi": 265308,
	"node_modules/monaco-editor/esm/vs/editor/common/services/editorBaseApi.js": 265308,
	"node_modules/monaco-editor/esm/vs/editor/common/services/editorSimpleWorker": 718941,
	"node_modules/monaco-editor/esm/vs/editor/common/services/editorSimpleWorker.js": 718941,
	"node_modules/monaco-editor/esm/vs/editor/common/services/editorWorker": 68633,
	"node_modules/monaco-editor/esm/vs/editor/common/services/editorWorker.js": 68633,
	"node_modules/monaco-editor/esm/vs/editor/common/services/editorWorkerHost": 151883,
	"node_modules/monaco-editor/esm/vs/editor/common/services/editorWorkerHost.js": 151883,
	"node_modules/monaco-editor/esm/vs/editor/common/services/findSectionHeaders": 78662,
	"node_modules/monaco-editor/esm/vs/editor/common/services/findSectionHeaders.js": 78662,
	"node_modules/monaco-editor/esm/vs/editor/common/services/getIconClasses": 604337,
	"node_modules/monaco-editor/esm/vs/editor/common/services/getIconClasses.js": 604337,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce": 581239,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce.js": 581239,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languageFeatures": 70015,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languageFeatures.js": 70015,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languageFeaturesService": 420920,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languageFeaturesService.js": 420920,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languageService": 874457,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languageService.js": 874457,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languagesAssociations": 473543,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languagesAssociations.js": 473543,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languagesRegistry": 292652,
	"node_modules/monaco-editor/esm/vs/editor/common/services/languagesRegistry.js": 292652,
	"node_modules/monaco-editor/esm/vs/editor/common/services/markerDecorations": 327929,
	"node_modules/monaco-editor/esm/vs/editor/common/services/markerDecorations.js": 327929,
	"node_modules/monaco-editor/esm/vs/editor/common/services/markerDecorationsService": 713394,
	"node_modules/monaco-editor/esm/vs/editor/common/services/markerDecorationsService.js": 713394,
	"node_modules/monaco-editor/esm/vs/editor/common/services/model": 967093,
	"node_modules/monaco-editor/esm/vs/editor/common/services/model.js": 967093,
	"node_modules/monaco-editor/esm/vs/editor/common/services/modelService": 401374,
	"node_modules/monaco-editor/esm/vs/editor/common/services/modelService.js": 401374,
	"node_modules/monaco-editor/esm/vs/editor/common/services/resolverService": 166921,
	"node_modules/monaco-editor/esm/vs/editor/common/services/resolverService.js": 166921,
	"node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensDto": 167011,
	"node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensDto.js": 167011,
	"node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling": 368964,
	"node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling.js": 368964,
	"node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensStyling": 942688,
	"node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensStyling.js": 942688,
	"node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService": 198401,
	"node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService.js": 198401,
	"node_modules/monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl": 783239,
	"node_modules/monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl.js": 783239,
	"node_modules/monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol": 892797,
	"node_modules/monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol.js": 892797,
	"node_modules/monaco-editor/esm/vs/editor/common/services/textResourceConfiguration": 652559,
	"node_modules/monaco-editor/esm/vs/editor/common/services/textResourceConfiguration.js": 652559,
	"node_modules/monaco-editor/esm/vs/editor/common/services/treeSitterParserService": 103783,
	"node_modules/monaco-editor/esm/vs/editor/common/services/treeSitterParserService.js": 103783,
	"node_modules/monaco-editor/esm/vs/editor/common/services/treeViewsDnd": 754122,
	"node_modules/monaco-editor/esm/vs/editor/common/services/treeViewsDnd.js": 754122,
	"node_modules/monaco-editor/esm/vs/editor/common/services/treeViewsDndService": 761295,
	"node_modules/monaco-editor/esm/vs/editor/common/services/treeViewsDndService.js": 761295,
	"node_modules/monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter": 563664,
	"node_modules/monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter.js": 563664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170449;